
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader, Col,
  Container,
  Form,
} from "reactstrap";
import AdminService from "../../../services/adminService";
import AdminForm from "./Form";
import FormInput from "../../../components/common/form/FormInput";
import UtilService from "../../../services/utilService";
import TenantService from "../../../services/tenantService";
import Loader from "../../Loader";
import _ from "lodash";

class AdminCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorData: {},
      file:null,
      middleName:'',
      userCompanyName:'',
      fileSelectUUID:UtilService.uuidv4(),
      loading:false,
      reviewsSearchEnabled:false,
      isPartner:false,
      selectKey: UtilService.uuidv4(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
  }

  handleCountrySelectChange(valueObj) {
    console.log(valueObj)
    if (_.isNull(valueObj)) {
      this.setState({selectedCountries: {}, allowedCountries: []});
    } else {
      const countries =  _.map(valueObj, "key")
      console.log(countries)
      this.setState({selectedCountries: valueObj, allowedCountries:countries, selectKey: UtilService.uuidv4()});
    }
  }

  handleChange(event) {
    if(event.target.type === "checkbox") {
      this.setState({[event.target.name]: event.target.checked});
    } else{
      this.setState({[event.target.name]: event.target.value});
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({loading: true})
    const data = new FormData()
    data.append('file', this.state.file)
    data.append('adminRole', this.state?.adminRole)
    data.append('emailAddress', this.state?.emailAddress)
    data.append('firstName', this.state?.firstName)
    data.append('middleName', this.state?.middleName)
    data.append('lastName', this.state?.lastName)
    data.append('userCompanyName', this.state?.userCompanyName)
    data.append('reviewsSearchEnabled', this.state?.reviewsSearchEnabled)
    data.append('isPartner', this.state?.isPartner)
    data.append('allowedCountries', this.state?.allowedCountries || [])
    AdminService.create(data).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        this.props.history.push("/crm/list");
      } else {
        this.setState({ errorData: response.data });
      }
      this.setState({loading: false})
    });
  }
  fileChange = (event) => {
    this.setState({file: event.target.files[0]})
  };


  render() {
    return (
      <>
        <SimpleHeader
          name="Create"
          parentName="User"
          heading="ClashMate"
          newBtnUrl="/crm/list"
          newBtnText="List All Users"
        />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Create User</h3>
            </CardHeader>
            {this.state.loading && <Loader />}
            <CardBody>
              <Form role="form" onSubmit={this.handleSubmit}>
                <AdminForm
                  onChange={this.handleChange}
                  valueObj={this.state}
                  errorObj={this.state.errorData}
                  isEdit={false}
                  fileChange = {this.fileChange}
                  fileSelectUuid = {this.state.fileSelectUUID}
                  selectedRole = {this.state.adminRole}
                  handleCountrySelectChange = {this.handleCountrySelectChange}
                />
                <div className="text-center">
                  <Button className="my-4" color="default" outline type="submit">
                    Submit
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default AdminCreate;
